<div class="p-4 text-on-surface">
  <header class="mb-4 flex flex-col gap-y-1 text-body-small">
    <h1 class="text-title-large">{{ title }}</h1>

    <p>Printed {{ printedAt }}</p>

    @if (filterSummary.length > 0) {
      <ul>
        @for (filter of filterSummary; track $index) {
          <li><span class="font-medium">{{ filter.label }}:</span> {{ filter.values }}</li>
        }
      </ul>
    }

    <p>{{ rowCountSummary }}</p>
  </header>

  <table class="w-full table-fixed border-collapse printable-table-typography">
    <thead>
    <tr>
      @for (header of headers; track $index) {
        <th scope="col" class="text-start align-bottom border-b-2 border-current pb-1 pe-3 {{ header.widthCssClasses }}">{{ header.label }}</th>
      }
    </tr>
    </thead>

    <tbody>
      @for (row of rows; track $index) {
        <tr>
          @for (cell of row; track $index) {
            <td class="align-top border-b border-outline-variant py-1 pe-3 break-words"
                [class.override-screen-typography]="cell.isComponent && cell.overrideScreenTypography">
              @if (cell.isComponent) {
                <!-- Note that the ! assertion on cell.componentClass is only to satisfy IntelliJ.  It doesn't recognize the cell.isComponent narrowing. -->
                <ng-container [ngComponentOutlet]="cell.componentClass!" [ngComponentOutletInputs]="cell.componentInputs"/>
              } @else {
                {{ cell.text }}
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
